export const Cities = {
  Punjab: {
    MAJHA: {
      AMRITSAR: ["Amritsar"],
      GURDASPUR: ["Gurdaspur"],
      PATHANKOT: ["Pathankot"],
      TARN_TARAN: ["Tarn Taran"],
    },
    MALWA: {
      LUDHIANA: ["Ludhiana"],
      PATIALA: ["Patiala"],
      BATHINDA: ["Bathinda"],
      FEROZEPUR: ["Ferozepur"],
      MOGA: ["Moga"],
      SANGRUR: ["Sangrur"],
      MUKTSAR: ["Sri Muktsar Sahib"],
      FARIDKOT: ["Faridkot"],
      MANSA: ["Mansa"],
      BARNALA: ["Barnala"],
      FATEHGARH_SAHIB: ["Fatehgarh Sahib"],
      RUPNAGAR: ["Rupnagar"],
      SAS_NAGAR: ["S.A.S Nagar (Mohali)"],
    },
    DOABA: {
      JALANDHAR: ["Jalandhar"],
      HOSHIARPUR: ["Hoshiarpur"],
      KAPURTHALA: ["Kapurthala"],
      SBS_NAGAR: ["Shahid Bhagat Singh Nagar (Nawanshahr)"],
    },
    PUADH: {
      FATEHGARH_SAHIB: ["Fatehgarh Sahib"],
      PATIALA: ["Patiala"],
      SAS_NAGAR: ["S.A.S Nagar (Mohali)"],
      RUPNAGAR: ["Rupnagar"],
    },
  },
  Rajasthan: {
    AJMER: {
      AJMER: ["Ajmer", "Beawar", "Kishangarh"], // Real cities
      BHILWARA: ["Bhilwara", "Rajsamand", "Mandalgarh"],
      NAGAUR: ["Nagaur", "Didwana", "Merta City"],
      TONK: ["Tonk", "Deoli", "Malpura"],
    },
    BHARATPUR: {
      BHARATPUR: ["Bharatpur", "Karauli", "Dholpur"],
      DHOLPUR: ["Dholpur", "Bari", "Sarai"],
      KARAULI: ["Karauli", "Hindaun", "Weir"],
      SAWAI_MADHOPUR: ["Sawai Madhopur", "Chauth Ka Barwara", "Khandar"],
    },
    BIKANER: {
      BIKANER: ["Bikaner", "Deshnok", "Palsana"],
      CHURU: ["Churu", "Sardarshahar", "Taranagar"],
      HANUMANGARH: ["Hanumangarh", "Nohar", "Sangaria"],
      GANGANAGAR: ["Sri Ganganagar", "Padampur", "Anupgarh"],
    },
    JAIPUR: {
      JAIPUR: ["Jaipur", "Sanganer", "Malviya Nagar"],
      DAUSA: ["Dausa", "Lalsot", "Bandikui"],
      SIKAR: ["Sikar", "Danta Ramgarh", "Raja Park"],
      ALWAR: ["Alwar", "Bhiwadi", "Neemrana"],
      JHUNJHUNU: ["Jhunjhunu", "Nawalgarh", "Udaipurwati"],
    },
    JODHPUR: {
      JODHPUR: ["Jodhpur", "Osian", "Pali"],
      BARMER: ["Barmer", "Siwana", "Jaisalmer"],
      JALORE: ["Jalore", "Sanchore", "Raniwara"],
      PALI: ["Pali", "Sojat", "Marwar Junction"],
      SIROHI: ["Sirohi", "Abu Road", "Pindwara"],
    },
    KOTA: {
      KOTA: ["Kota", "Bundi", "Jhalawar"],
      BUNDI: ["Bundi", "Taraori", "Keshoraipatan"],
      BARAN: ["Baran", "Chhabra", "Atru"],
      JHALAWAR: ["Jhalawar", "Kailashpuri", "Ratangarh"],
    },
    UDAIPUR: {
      UDAIPUR: ["Udaipur", "Mount Abu", "Rajsamand"],
      BANSWARA: ["Banswara", "Kushalgarh", "Ghatol"],
      CHITTORGARH: ["Chittorgarh", "Nimbahera", "Bhadesar"],
      DUNGARPUR: ["Dungarpur", "Sagwara", "Bichhiwara"],
      RAJSAMAND: ["Rajsamand", "Kankroli", "Nathdwara"],
      PRATAPGARH: ["Pratapgarh", "Chhoti Sadri", "Pipalgaon"],
    },
  },
  Haryana: {
    "AMBALA DIVISION": {
      AMBALA: ["Ambala City", "Ambala Cantt"],
      PANCHKULA: ["Panchkula", "Pinjore", "Zirakpur"],
      YAMUNANAGAR: ["Yamunanagar", "Jagadhri", "Bilaspur"],
    },
    "ROHTAK DIVISION": {
      ROHTAK: ["Rohtak", "Meham", "Kalanaur"],
      JHAJJAR: ["Jhajjar", "Bahadurgarh", "Bhiwani"],
      SONIPAT: ["Sonipat", "Ganaur", "Kharkhoda"],
    },
    "GURGAON DIVISION": {
      GURGAON: ["Gurgaon", "Manesar", "Sohna"],
      FARIDABAD: ["Faridabad", "Ballabgarh", "Tigaon"],
      NUH: ["Nuh", "Pehowa", "Firozpur Jhirka"],
      REWARI: ["Rewari", "Bawal", "Kosli"],
      PALWAL: ["Palwal", "Hodal", "Prithla"],
    },
    "HISAR DIVISION": {
      HISAR: ["Hisar", "Barwala", "Narnaund"],
      BHIWANI: ["Bhiwani", "Charkhi Dadri", "Bhiwani"],
      FATEHABAD: ["Fatehabad", "Ratia", "Tosham"],
      JIND: ["Jind", "Hansi", "Uchana"],
      SIRSA: ["Sirsa", "Dabwali", "Rania"],
    },
  },
  "Uttar Pradesh": {
    AGRA: {
      AGRA: ["Agra", "Fatehabad", "Kheragarh"],
      FIROZABAD: ["Firozabad", "Shikohabad", "Tundla"],
      MAINPURI: ["Mainpuri", "Bhongaon", "Ghiror"],
      MATHURA: ["Mathura", "Vrindavan", "Goverdhan"],
    },
    ALLAHABAD: {
      PRAYAGRAJ: ["Prayagraj", "Phulpur", "Karchana"],
      FATEHPUR: ["Fatehpur", "Bindki", "Khaga"],
      KAUSHAMBI: ["Kaushambi", "Manjhanpur", "Chail"],
      PRATAPGARH: ["Pratapgarh", "Kunda", "Patti"],
    },
    AZAMGARH: {
      AZAMGARH: ["Azamgarh", "Mubarakpur", "Nizamabad"],
      MAU: ["Mau", "Ghosi", "Kopaganj"],
      BALLIA: ["Ballia", "Bansdih", "Rasra"],
    },
    BAREILLY: {
      BAREILLY: ["Bareilly", "Nawabganj", "Fatehganj"],
      BUDAUN: ["Budaun", "Sahaswan", "Bisauli"],
      PILIBHIT: ["Pilibhit", "Puranpur", "Bisalpur"],
      SHAHJAHANPUR: ["Shahjahanpur", "Tilhar", "Jalalabad"],
    },
    CHITRAKOOT: {
      BANDA: ["Banda", "Naraini", "Atarra"],
      CHITRAKOOT: ["Chitrakoot", "Karwi", "Manikpur"],
      HAMIRPUR: ["Hamirpur", "Rath", "Maudaha"],
      MAHOBA: ["Mahoba", "Kulpahar", "Charkhari"],
    },
    FAIZABAD: {
      AYODHYA: ["Ayodhya", "Faizabad", "Rudauli"],
      AMBEDKAR_NAGAR: ["Akbarpur", "Tanda", "Jalalpur"],
      BARABANKI: ["Barabanki", "Ramnagar", "Fatehpur"],
      SULTANPUR: ["Sultanpur", "Kadipur", "Lambhua"],
      AMETHI: ["Amethi", "Gauriganj", "Musafirkhana"],
    },
    GORAKHPUR: {
      GORAKHPUR: ["Gorakhpur", "Sahjanwa", "Bansgaon"],
      DEORIA: ["Deoria", "Rudrapur", "Salempur"],
      KUSHINAGAR: ["Kushinagar", "Padrauna", "Tamkuhi Raj"],
      MAHARAJGANJ: ["Maharajganj", "Nautanwa", "Anandnagar"],
    },
    JHANSI: {
      JHANSI: ["Jhansi", "Mauranipur", "Garautha"],
      LALITPUR: ["Lalitpur", "Talbehat", "Mahroni"],
      JALAUN: ["Orai", "Kalpi", "Konch"],
    },
    KANPUR: {
      KANPUR_NAGAR: ["Kanpur", "Bithoor", "Ghatampur"],
      KANPUR_DEHAT: ["Akbarpur", "Derapur", "Rura"],
      AURAIYA: ["Auraiya", "Dibiyapur", "Bidhuna"],
      FARRUKHABAD: ["Farrukhabad", "Kaimganj", "Shamsabad"],
    },
    LUCKNOW: {
      LUCKNOW: ["Lucknow", "Malihabad", "Mohanlalganj"],
      HARDOI: ["Hardoi", "Sandila", "Shahabad"],
      LAKHIMPUR_KHERI: ["Lakhimpur", "Gola Gokarannath", "Palia"],
      RAE_BARELI: ["Rae Bareli", "Lalganj", "Dalmau"],
      SITAPUR: ["Sitapur", "Maholi", "Biswan"],
      UNNAO: ["Unnao", "Safipur", "Purwa"],
    },
    MEERUT: {
      MEERUT: ["Meerut", "Mawana", "Sardhana"],
      BAGHPAT: ["Baghpat", "Baraut", "Khekra"],
      GHAZIABAD: ["Ghaziabad", "Loni", "Modinagar"],
      HAPUR: ["Hapur", "Pilkhuwa", "Gulaothi"],
      GAUTAM_BUDDHA_NAGAR: ["Noida", "Greater Noida", "Dadri"],
      BULANDSHAHR: ["Bulandshahr", "Sikandrabad", "Khurja"],
    },
    MIRZAPUR: {
      MIRZAPUR: ["Mirzapur", "Vindhyachal", "Chunar"],
      SONBHADRA: ["Robertsganj", "Obra", "Renukoot"],
      BHADOHI: ["Bhadohi", "Gyanpur", "Suriyawan"],
    },
    MORADABAD: {
      MORADABAD: ["Moradabad", "Kundarki", "Bilari"],
      AMROHA: ["Amroha", "Dhanaura", "Hasanpur"],
      BIJNOR: ["Bijnor", "Nagina", "Dhampur"],
      RAMPUR: ["Rampur", "Suar", "Tanda"],
      SAMBHAL: ["Sambhal", "Chandausi", "Bahjoi"],
    },
    SAHARANPUR: {
      SAHARANPUR: ["Saharanpur", "Behat", "Deoband"],
      SHAMLI: ["Shamli", "Kairana", "Thana Bhawan"],
      MUZAFFARNAGAR: ["Muzaffarnagar", "Budhana", "Khatauli"],
    },
    VARANASI: {
      VARANASI: ["Varanasi", "Ramnagar", "Raja Talab"],
      CHANDAULI: ["Chandauli", "Mughalsarai", "Sakaldiha"],
      GHAZIPUR: ["Ghazipur", "Saidpur", "Zamania"],
      JAUNPUR: ["Jaunpur", "Shahganj", "Kerakat"],
    },
  },
};
